import { useContentShareControls, useLocalVideo, useMeetingManager, useToggleLocalMute, useContentShareState, } from 'amazon-chime-sdk-component-library-react';
import { useEffect } from 'react';
import { useVideoConfig } from '../video-config-provider';
import { useSignalingApi } from '../../signaling-api';
export var SyncProps = function () {
    var _a = useVideoConfig(), video = _a.video, audio = _a.audio, camera = _a.camera, microphone = _a.microphone, speaker = _a.speaker, onSetScreenShare = _a.onSetScreenShare, onLoadScreenShare = _a.onLoadScreenShare, onScreenShare = _a.onScreenShare;
    var _b = useLocalVideo(), isVideoEnabled = _b.isVideoEnabled, toggleVideo = _b.toggleVideo;
    var _c = useToggleLocalMute(), muted = _c.muted, toggleMute = _c.toggleMute;
    var _d = useContentShareState(), isLocalUserSharing = _d.isLocalUserSharing, isLocalShareLoading = _d.isLocalShareLoading;
    var onToggleScreenshare = useSignalingApi().onToggleScreenshare;
    var toggleContentShare = useContentShareControls().toggleContentShare;
    var _e = useMeetingManager(), selectedVideoInputDevice = _e.selectedVideoInputDevice, selectedAudioInputDevice = _e.selectedAudioInputDevice, selectedAudioOutputDevice = _e.selectedAudioOutputDevice, selectVideoInputDevice = _e.selectVideoInputDevice, selectAudioInputDevice = _e.selectAudioInputDevice, selectAudioOutputDevice = _e.selectAudioOutputDevice;
    useEffect(function () {
        if (isVideoEnabled !== video) {
            toggleVideo();
        }
    }, [video]);
    useEffect(function () {
        if (muted === audio) {
            toggleMute();
        }
    }, [audio]);
    useEffect(function () {
        return onToggleScreenshare(function (enabled) {
            void (onScreenShare === null || onScreenShare === void 0 ? void 0 : onScreenShare(enabled));
            if (enabled !== isLocalUserSharing) {
                void toggleContentShare();
            }
        });
    }, [isLocalUserSharing]);
    useEffect(function () {
        onSetScreenShare(isLocalUserSharing);
    }, [isLocalUserSharing]);
    useEffect(function () {
        onLoadScreenShare(isLocalShareLoading);
    }, [isLocalShareLoading]);
    useEffect(function () {
        if (selectedVideoInputDevice !== camera) {
            selectVideoInputDevice(camera).catch(console.log);
        }
    }, [camera, selectedVideoInputDevice]);
    useEffect(function () {
        if (selectedAudioInputDevice !== microphone) {
            selectAudioInputDevice(microphone).catch(console.log);
        }
    }, [microphone, selectedAudioInputDevice]);
    useEffect(function () {
        if (selectedAudioOutputDevice !== speaker) {
            if ('setSinkId' in HTMLMediaElement.prototype) {
                selectAudioOutputDevice(speaker).catch(console.log);
            }
            else {
                console.log('setSinkId is not supported skipping speaker selection');
            }
        }
    }, [speaker, selectedAudioOutputDevice]);
    return null;
};
//# sourceMappingURL=sync-props.js.map